import { useMemo } from 'react'
import * as Yup from 'yup'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { allowedLogoNameInputCharactersPattern } from '../../../../containers/EmbroideryService/utils'
import { Props as TextEmbroideryValidationSchemaProps } from '../TextEmbroideryForm/useValidationSchema'

interface Props extends TextEmbroideryValidationSchemaProps {}

export const useLogoSetupValidationSchema = ({ textMaxChars }: Props) => {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      __type: Yup.mixed().oneOf(['DTCLogoEmbroideryFormValues']),
      name: Yup.string()
        .trim()
        .required(fixtures.validationErrorMessages.requiredLogoName)
        .matches(
          allowedLogoNameInputCharactersPattern,
          fixtures.validationErrorMessages.allowedTextCharacters
        )
        .max(
          textMaxChars,
          fixtures.validationErrorMessages.textMaxCharsTemplate.replace(
            '{{max}}',
            textMaxChars.toString()
          )
        ),
      notes: Yup.string(),
      file: Yup.mixed().required(fixtures.validationErrorMessages.requiredFile),
      digitization_setting: Yup.mixed()
        .oneOf(['BLACK_WHITE', 'COLOR'])
        .required(fixtures.validationErrorMessages.requiredDigitizationSetting),
      tos: Yup.array()
        .of(Yup.string())
        .min(1, fixtures.validationErrorMessages.requiredTos)
        .max(1)
        .required(fixtures.validationErrorMessages.requiredTos),
    })
  }, [fixtures.validationErrorMessages, textMaxChars])

  return validationSchema
}
